// extracted by mini-css-extract-plugin
export default {"textContainer":"project-infos-component_textContainer__A5Xm5","title":"project-infos-component_title__tvY23","description":"project-infos-component_description__bu0ZT"};